// AI output is rendered as plain text (whitespace-pre-wrap), so any Markdown the
// model emits shows up as literal characters. The prompts forbid Markdown, but
// compliance is not guaranteed — this strips what slips through.
// Only the markers are removed; the wording, numbering and line breaks stay.
export const stripMarkdown = (text) => {
  if (typeof text !== 'string') return text

  return text
    .replace(/^\s{0,3}#{1,6}[ \t]+/gm, '')   // ## 見出し
    .replace(/\*\*(.+?)\*\*/gs, '$1')        // **強調**
    .replace(/__(.+?)__/gs, '$1')            // __強調__
    .replace(/\*\*/g, '')                    // 閉じ忘れた **
    .replace(/^\s{0,3}\*[ \t]+/gm, '・')      // * 箇条書き
}
